if (!customElements.get("nmn-routines")) {
  customElements.define(
    "nmn-routines",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const controls = this.querySelector(".nmn-routines__filters");
        this.cards = Array.from(this.querySelectorAll("[data-routine-period]"));
        this.filters = Array.from(this.querySelectorAll("button[data-period]"));
        if (!controls || !this.cards.length) return;
        const periods = new Set(this.cards.map((card) => card.dataset.routinePeriod));
        this.filters.forEach((button) => {
          button.hidden = !periods.has(button.dataset.period);
        });
        controls.hidden = periods.size < 2;
        this.period = periods.has(this.dataset.period)
          ? this.dataset.period
          : this.cards[0].dataset.routinePeriod;
        controls.addEventListener(
          "click",
          (event) => {
            const button = event.target.closest("button[data-period]");
            if (!button || !controls.contains(button)) return;
            this.period = button.dataset.period;
            this.update();
          },
          { signal: this.controller.signal },
        );
        document.addEventListener(
          "shopify:block:select",
          (event) => {
            const card = event.target.closest("[data-routine-period]");
            if (!card || !this.contains(card)) return;
            this.period = card.dataset.routinePeriod;
            this.update();
          },
          { signal: this.controller.signal },
        );
        this.update();
      }
      update() {
        const matching = this.cards.filter((card) => card.dataset.routinePeriod === this.period);
        this.dataset.period = this.period;
        this.dataset.cardCount = String(matching.length);
        this.cards.forEach((card) => {
          card.hidden = !matching.includes(card);
          card.classList.toggle("nmn-routines__card--large", card === matching[0]);
        });
        this.filters.forEach((button) => {
          button.setAttribute("aria-pressed", String(button.dataset.period === this.period));
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    },
  );
}
